import { AppManagerActionTypes } from "./actionTypes";
import { IAppManager, IRestaurantGroup } from "./types";

const initialState: IAppManager = {
  currLocation: "",
  currRestaurantGroupId: "",
  isLoading: true,
  currLanguage: "ru",
  allLocations: [],
  allRestaurantGroups: [],
  restaurantGroupLocations: [],
};

export const appManagerReducer = (
  state = initialState,
  action: any
): IAppManager => {
  switch (action.type) {
    case AppManagerActionTypes.APP_SET_CURR_LOCATION:
      return {
        ...state,
        currLocation: action.payload.location,
      };

    case AppManagerActionTypes.APP_SET_CURRENT_RESTAURANT_GROUP_ID:
      return {
        ...state,
        currRestaurantGroupId: action.payload?.restaurantGroupId,
        restaurantGroupLocations: action.payload?.allLocations,
        currLocation: action.payload.allLocations?.[0]?.restaurant_id,
      };

    case AppManagerActionTypes.APP_FETCH_RESTAURANT_GROUPS_SUCCESS:
      return {
        ...state,
        allRestaurantGroups: action.payload.restaurantGroups,
        currRestaurantGroupId: action.payload.currRestGroupId,
      };
    case AppManagerActionTypes.APP_FETCH_ALL_LOCATIONS_SUCCESS:
      return {
        ...state,
        allLocations: action.payload.allLocations.data,
        restaurantGroupLocations: action.payload.locations,
        currLocation: action.payload.currLocation,
        // fetchLocation: false
      };
    case AppManagerActionTypes.SET_CURRENT_LANGUAGE:
      return {
        ...state,
        currLanguage: action.payload,
      };
    case AppManagerActionTypes.SET_FULL_REFRESH_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
};
